// eslint-disable-next-line max-classes-per-file
export interface RequestGetFavouriteInterface {
  city_id: string;
}

class FavouriteHotelLocation {
  area_name: string = "";

  city_name: string = "";

  country_name: string = "";

  constructor(data: any) {
    this.area_name = data.area_name || "";
    this.city_name = data.city_name || "";
    this.country_name = data.country_name || "";
  }
}

export class FavouriteHotelItem {
  id: number = 0;

  name: string = "";

  slug: string = "";

  photo_path: string = "";

  rating: string = "";

  num_reviews: string = "";

  city_id: number = 0;

  region_id: string = "";

  area_id: number = 0;

  location: FavouriteHotelLocation;

  country_id: string = "";

  created_at: string = "";

  countrySlug: string = "";

  isGreenCertificate: boolean;

  citySlug: string = "";

  areaSlug: string = "";

  hotelSlugPath: string = "";

  text_rating_detail: string = "";

  constructor(data: any) {
    this.id = data.id || 0;
    this.name = data.name || "";
    this.slug = data.slug || "";
    this.photo_path = data.photo_path || "";
    this.rating = data.rating || "";
    this.num_reviews = data.num_reviews || "";
    this.city_id = data.city_id || 0;
    this.region_id = data.region_id || "";
    this.area_id = data.area_id || 0;
    this.location = new FavouriteHotelLocation(data.location);
    this.country_id = data.country_id || "";
    this.created_at = data.created_at || "";
    this.countrySlug = data.countrySlug || "";
    this.citySlug = data.citySlug || "";
    this.areaSlug = data.areaSlug || "";
    this.slug = data.slug || "";
    this.hotelSlugPath = `${this.countrySlug}/${this.citySlug}/${this.areaSlug}/${this.slug}/`;
    this.text_rating_detail = data.text_rating_detail || "";
    this.isGreenCertificate = data.isGreenCertificate || false;
  }
}

class IconProductTypeButton {
  active: string = "";

  inactive: string = "";
}

export class ResponseListItemFavourite {
  type: string = "";

  typeLang: string = "";

  isGreenCertificate?: boolean;

  count_data: number = 0;

  icon: IconProductTypeButton = new IconProductTypeButton();

  data: FavouriteHotelItem[] | [];

  constructor(data: any) {
    this.type = data.type || "";
    this.count_data = data.count_data || 0;
    this.isGreenCertificate = data?.isGreenCertificate || false;
    this.typeLang = data.typeLang || "";
    this.icon = data.icon || new IconProductTypeButton();
    this.data = (data.data || []).map((value: any) => {
      return new FavouriteHotelItem(value);
    });
  }
}
export class ResponseResultFavourite {
  result: ResponseListItemFavourite[] = [];

  constructor(data: any) {
    this.result = (data.result || []).map((value: any) => {
      return new ResponseListItemFavourite(value);
    });
  }
}

export class ResponseToggleFavourite {
  status: boolean;

  message: string;

  constructor(data: any) {
    this.message = data.message ?? "";
    this.status = data.status ?? false;
  }
}
